module.exports = __webpack_public_path__ + "static/media/8520997B-CCC9-485A-8E52-D5FFFD727AFF.8ce79de2.JPG";